module.exports = __webpack_public_path__ + "static/media/480.91f3c032.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-chainsaw/light/480.png
// module id = 1948
// module chunks = 2